export enum EndAssignmentReason {
  NotDefined = 0,
  CompletedEarly = 1,
  ConsultantUnavailable = 2,
  CustomerEnded = 3,
  PerformanceMismatch = 4,
  Other = 5,
}
